import createAction from '../../common/services/create-action';

export const START_EDITING_COMMENT = 'comment/START_EDITING';
export const startEditingComment = createAction(START_EDITING_COMMENT);
